import { render, staticRenderFns } from "./SpectroscopyTubeSIM.vue?vue&type=template&id=2395c489&"
import script from "./SpectroscopyTubeSIM.vue?vue&type=script&lang=ts&"
export * from "./SpectroscopyTubeSIM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports